import { Tooltip } from 'antd'
import { Trans, useLingui } from '@lingui/react/macro'

import type { ReactNode } from 'react'


import Link from '@/components/Link';
export interface FooterData {
  categoryTitle: string
  children: {
    label: ReactNode
    href?: string
    nofollow?: boolean
  }[]
}

export function useFooterData() {
  const { t } = useLingui()
  const list: FooterData[] = [
    {
      categoryTitle: t`Try Tad AI`,
      children: [
        {
          label: t`AI Music Generator`,
          href: '/ai-music-generator',
        },
        {
          label: t`AI Rap Generator`,
          href: '/ai-rap-generator',
        },
        {
          label: t`AI Cover Generator`,
          href: '/ai-cover-generator',
        },
        {
          label: t`Text to Speech`,
          href: '/text-to-speech',
        },
      ],
    },
    {
      categoryTitle: t`Resources`,
      children: [
        // {
        //   label: t`Suno`,
        //   href: '/suno',
        // },
        // {
        //   label: t`Udio`,
        //   href: '/udio',
        // },
        {
          label: t`Suno Alternatives`,
          href: '/hub/best-suno-alternatives',
        },
        {
          label: t`Udio Alternatives`,
          href: '/hub/best-udio-alternatives',
        },
        {
          label: t`Donna AI Review`,
          href: '/hub/donna-ai-review',
        },
        {
          label: t`Google Lyria 2 Review`,
          href: '/hub/google-lyria-2-review',
        },
        // {
        //   label: t`Soundraw Alternatives`,
        //   href: '/hub/best-soundraw-alternatives',
        // },
        // {
        //   label: t`Beatoven Alternatives`,
        //   href: '/hub/best-beatoven-ai-alternatives',
        // },
        {
          label: t`More Resources`,
          href: '/hub',
        },
      ],
    },
    {
      categoryTitle: t`Reviews`,
      children: [
        {
          label: t`Suno`,
          href: '/suno',
        },
        {
          label: t`Udio`,
          href: '/udio',
        },
        {
          label: t`Musicfy`,
          href: '/musicfy',
        },
        {
          label: t`Riffusion`,
          href: '/riffusion',
        },
        {
          label: t`More Reviews`,
          href: '/reviews',
        },
      ],
    },
    {
      categoryTitle: t`Company`,
      children: [
        {
          label: t`About Us`,
          href: '/about-us',
        },
        {
          label: (
            <Tooltip title={t`support@tad.ai`}>
              <Link
                className='hover:underline hover:opacity-100'
                href='mailto:support@tad.ai'
                rel='nofollow noreferrer'
              >
                <Trans>Contact Us</Trans>
              </Link>
            </Tooltip>
          ),
        },
        // {
        //   label: 'Affiliate Program',
        //   href: '/affiliate-program',
        // },
        {
          label: t`Refund Policy`,
          href: '/refund-policy',
          nofollow: true,
        },
        {
          label: t`Privacy Policy`,
          href: '/privacy',
          nofollow: true,
        },
        {
          label: t`Terms & Conditions`,
          href: '/terms',
          nofollow: true,
        },
      ],
    },
  ]
  return list
}
